module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_12.1ebd80ce.jpeg";